import React from 'react';
// components
import SvgIconStyle from '../../../../components/SvgIconStyle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Iconify from '../../../../components/Iconify';
import ArticleIcon from '@mui/icons-material/Article';
import PeopleIcon from '@mui/icons-material/People';
import GavelIcon from '@mui/icons-material/Gavel';
import LockIcon from '@mui/icons-material/Lock';
import SchoolIcon from '@mui/icons-material/School';
import FolderIcon from '@mui/icons-material/Folder';
import DescriptionIcon from '@mui/icons-material/Description';
import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { useSelector } from 'react-redux';
import { ManageAccounts } from '@mui/icons-material';


// ----------------------------------------------------------------------

// Public function for obtaining proper navbar selections. Configs should not be imported directly
export const getNavConfig = () => {
  const { module, group } = useSelector(state => state.app);
  if (module === 'rekrutacja') {
    return navConfigRecrutation;
  } else if (module == 'obozy') {
    return obozyNavConfig;
  } else if (module == 'zielone_szkoly') {
    return zsNavConfig;
  }

  if (group === 'guest') {
    return guestNavConfig;
  }

  return navConfig;
};

const getIcon = name => (
  <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking')
};

export const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Ogólne',
    items: [
      {
        title: 'Zamówienia',
        path: 'orders',
        icon: <Iconify icon="icon-park-outline:transaction-order" />
      },
      {
        title: 'Formularze',
        path: 'form-list',
        icon: <Iconify icon="clarity:form-line" />
      },
      {
        title: 'Rozrachunki',
        path: 'settlements',
        icon: ICONS.banking,
        permission: 'view_settlements'
      },
      { title: 'Kartoteki', path: 'records', icon: ICONS.booking },
      {
        title: 'Powiadomienia',
        path: 'notifications',
        icon: <NotificationsIcon />
      },
      // { title: 'Szablony Umów', path: 'templates', icon: <AssignmentIcon /> },
      {
        title: 'Ankiety',
        path: 'survey',
        icon: <Iconify icon="fluent-mdl2:questionnaire" />
      },
      { title: 'Statystyki', path: 'statistics', icon: ICONS.analytics },
      { title: 'TFG', path: 'tfg', icon: <SyncAltIcon /> }
    ]
  }
];

export const zsNavConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Ogólne',
    items: [
      {
        title: 'Zamówienia',
        path: 'orders',
        icon: <Iconify icon="icon-park-outline:transaction-order" />
      },
      { title: 'Kalendarz sprzedażowy', path: 'sale-calendar', icon: ICONS.calendar },
      {
        title: 'Formularze',
        path: 'form-list',
        icon: <Iconify icon="clarity:form-line" />
      },
      {
        title: 'Rozrachunki',
        path: 'settlements',
        icon: ICONS.banking,
        permission: 'view_settlements'
      },
      { title: 'Kartoteki', path: 'records', icon: ICONS.booking },
      {
        title: 'Powiadomienia',
        path: 'notifications',
        icon: <NotificationsIcon />
      },
      // { title: 'Szablony Umów', path: 'templates', icon: <AssignmentIcon /> },
      {
        title: 'Ankiety',
        path: 'survey',
        icon: <Iconify icon="fluent-mdl2:questionnaire" />
      },
      { title: 'Statystyki', path: 'statistics', icon: ICONS.analytics },
      { title: 'TFG', path: 'tfg', icon: <SyncAltIcon /> }
    ]
  }
];

export const obozyNavConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Ogólne',
    items: [
      {
        title: 'Zamówienia',
        path: 'orders',
        icon: <Iconify icon="icon-park-outline:transaction-order" />
      },
      {
        title: 'Formularze',
        path: 'form-list',
        icon: <Iconify icon="clarity:form-line" />
      },
      {
        title: 'Rozrachunki',
        path: 'settlements',
        icon: ICONS.banking,
        permission: 'view_settlements'
      },
      { title: 'Kartoteki', path: 'records', icon: ICONS.booking },
      {
        title: 'Powiadomienia',
        path: 'notifications',
        icon: <NotificationsIcon />
      },
      // { title: 'Szablony Umów', path: 'templates', icon: <AssignmentIcon /> },
      {
        title: 'Ankiety',
        path: 'survey',
        icon: <Iconify icon="fluent-mdl2:questionnaire" />
      },
      { title: 'Statystyki', path: 'statistics', icon: ICONS.analytics },
      { title: 'Zakwaterowanie', path: 'accommodation', icon: ICONS.calendar },
      { title: 'TFG', path: 'tfg', icon: <SyncAltIcon /> }
    ]
  }
];

export const navConfigRecrutation = [
  // Navbar option for recrutation module
  {
    subheader: 'Ogólne',
    items: [
      { title: 'Pracownicy', path: 'employees', icon: <PeopleIcon /> },
      { title: 'Aplikacje', path: 'applications', icon: <ArticleIcon /> },
      {
        title: 'Formularze',
        path: 'r-form-list',
        icon: <Iconify icon="clarity:form-line" />
      },
      { title: 'Kartoteki', path: 'records', icon: ICONS.booking },
      {
        title: 'Powiadomienia',
        path: 'notifications',
        icon: <NotificationsIcon />
      },
      // {
      //   title: 'Szablony Umów',
      //   path: 'templates',
      //   icon: <AssignmentIcon />
      // },
      {
        title: 'Konta kadry',
        path: 'accounts-management',
        icon: <ManageAccounts />
      },
      {
        title: 'Standardy Pracy',
        path: 'work-standards',
        icon: <GavelIcon />
      },
      {
        title: 'Ochrona danych osobowych',
        path: 'personal-data-protection-documents',
        icon: <LockIcon />
      },
      {
        title: 'Instrukcje org. obozów',
        path: 'organizing-camps-instruction-documents',
        icon: <SchoolIcon />
      },
      {
        title: 'Niezbędniki',
        path: 'essential-documents',
        icon: <DescriptionIcon />
      },
      {
        title: 'Szablony dokumentów',
        path: 'template-documents',
        icon: <ChromeReaderModeIcon />
      },
      {
        title: 'Dokumenty organizacyjne',
        path: 'organizational-documents',
        icon: <FolderIcon />
      }
    ]
  }
];

export const guestNavConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Ogólne',
    items: [{ title: 'Raporty', path: 'getpaid-excel', icon: ICONS.analytics }]
  }
];
